<template>
  <div class="notice_detail">
    <NoticeSearch></NoticeSearch>
    <div class="crumbs_box">
      <div class="crumbs_content content_auto">
        <span @click="jumpTo('/notice')">{{ $t('公告中心') }}</span>
        <img src="./../../assets/images/right_arrow.png" alt="" />
        <span>{{ $t('公告详情') }}</span>
      </div>
    </div>
    <div class="detail content_auto">
      <!-- <div class="title_left">
        <h2>{{ $t('相关文章') }}</h2>
        <ul class="title_ul">
          <li
            :class="{ titleActive: shimTitle === item.id }"
            class="title_li"
            v-for="(item, index) in relevantList"
            :key="index"
            @click="handleTitle(item.id)"
          >
            {{ [item.title, 8] | strNum }}
          </li>
        </ul>
        <div class="look_more" @click="jumpTo('/notice')">
          <span>{{ $t('查看更多') }}</span>
          <img src="./../../assets/images/jinru.png" alt="" />
        </div>
      </div> -->
      <div class="content_right">
        <h1 class="title">{{ noticeTitle }}</h1>
        <div v-html="noticeContent" class="content"></div>
        <div class="return_top" @click="handleBackTop()">
          {{ $t('返回顶部') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoticeSearch from './components/NoticeSearch'
import { noticeList, noticeDetail } from '@/api/notice'
import { scrollTo } from '@/utils/scrollTo'
export default {
  components: {
    NoticeSearch
  },
  data() {
    return {
      shimTitle: '',
      relevantList: [],
      noticeTitle: '',
      noticeContent: ''
    }
  },
  created() {
    const queryId = Number(this.$route.query.id)
    const detailPromise = this.getNoticeDetail(queryId)
    // const listPromise = this.getNoticeList()
    Promise.all([detailPromise, listPromise]).then(() => {
      this.shimTitle = queryId
    })
  },
  watch: {
    $route(newVal, oldVal) {
      this.shimTitle = newVal.query.id
      this.getNoticeDetail(newVal.query.id)
    }
  },
  methods: {
    jumpTo(p) {
      this.$router.push({ path: p })
    },
    handleTitle(id) {
      this.shimTitle = id
      this.getNoticeDetail(id)
    },
    handleBackTop() {
      scrollTo(0, 800)
    },
    getNoticeList() {
      return noticeList({})
        .then((res) => {
          this.relevantList = res.data.data.list.slice(0, 5)
        })
        .catch((err) => {
          this.$Message.error({
            message: err.data.message
          })
        })
    },
    async getNoticeDetail(id) {
      const { content, title } = await noticeDetail({ noticeId: id })
      this.noticeTitle = title
      this.noticeContent = content
    }
  }
}
</script>
<style lang="less" scoped>
.notice_detail {
  .crumbs_box {
    padding: 4px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.1);
    .crumbs_content {
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      span:first-child {
        cursor: pointer;
      }
    }
  }
  .detail {
    padding-bottom: 100px;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    .title_left {
      h2 {
        padding-top: 10px;
        padding-bottom: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, 'PingFang SC';
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
      }
      .title_ul {
        overflow: hidden;
        .title_li {
          margin-top: 10px;
          padding: 10px 20px;
          width: 182px;
          height: 60px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          cursor: pointer;
        }
        // 动态控制背景和字体颜色
        .titleActive {
          color: rgba(255, 255, 255, 1);
          background: rgba(66, 179, 250, 1);
        }
      }
      .look_more {
        display: inline-block;
        margin-top: 40px;
        margin-left: 20px;
        cursor: pointer;
        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(66, 179, 250, 1);
          line-height: 20px;
        }
      }
    }
    .content_right {
      flex-grow: 1;
      // margin-left: 20px;
      padding: 0 20px 20px;
      // border-left: 1px solid rgba(151, 151, 151, 1);
      .title {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, 'PingFang SC';
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }
      .content {
        margin-top: 40px;
        padding-bottom: 40px;
        min-height: calc(100vh - 600px);
        border-bottom: 1px solid rgba(151, 151, 151, 1);
      }
      .return_top {
        margin-top: 40px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(66, 179, 250, 1);
        line-height: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
